import type { WidgetProps } from "../registry";
import type { ConfirmationPayload } from "../../../generated-api";

export type ConfirmationResult = {
  confirmed: boolean;
};

export function ConfirmationWidget({
  payload,
  onComplete,
}: WidgetProps<ConfirmationPayload>) {
  const { message, confirmLabel = "Yes", cancelLabel = "No" } = payload;

  return (
    <div className="flex flex-col gap-3 mt-1">
      <p className="text-sm text-text-primary">
        {message ?? "Please confirm."}
      </p>
      <div className="flex gap-2">
        <button
          type="button"
          onClick={() => onComplete({ confirmed: true })}
          className="px-4 py-2 text-sm font-medium rounded-lg bg-indigo-600 text-white hover:bg-indigo-700 transition-colors"
        >
          {confirmLabel}
        </button>
        <button
          type="button"
          onClick={() => onComplete({ confirmed: false })}
          className="px-4 py-2 text-sm font-medium rounded-lg border border-border text-text-primary hover:bg-bg-secondary transition-colors"
        >
          {cancelLabel}
        </button>
      </div>
    </div>
  );
}
